<template>
    <CustomDialog
        v-model="show"
        hideHeader
        hideCloseIcon
        hideFooter
        persistent
    >
        <div class="flex flex-col items-center py-7.5 px-5.5 max-mob:px-4 w-120 max-mob:w-full">
            <PartyPopper class="max-mob:w-8 max-mob:h-8 mb-8.5"/>

            <div class="mb-8.5 max-mob:mb-4 grid gap-y-2.5 text-center">
                <div class="text-xxxl max-mob:text-xl text-gray-370 dark:text-white font-medium">
                    Welcome to Dialics for Affiliates
                </div>

                <div class="px-5 text-sm max-mob:text-xs text-gray-280">
                    Share the affiliate link and earn money with every dollar spent by your referrals
                </div>
            </div>

            <div class="flex flex-col">
                <div class="px-5 max-mob:px-0 py-3">
                    <div class="flex gap-x-3">
                        <div class="min-w-8 max-w-8 min-h-8 max-h-8 flex items-center justify-center">
                            <CheckIcon class="text-purple"/>
                        </div>

                        <div class="flex flex-col gap-y-3">
                            <div class="text-gray-370 dark:text-white font-medium">
                                Share the referral link
                            </div>

                            <div class="text-sm text-gray-280">
                                Copy and distribute the link among those interested in the Dialics platform
                            </div>
                            <div class="flex items-center gap-x-2">
                                <div class="text-xs text-gray-370 dark:text-white font-medium">
                                    Referral link:
                                </div>

                                <a
                                    class="flex items-center gap-x-2 py-1 px-2 bg-purple-50 dark:bg-blue-770 rounded-1.25 cursor-pointer"
                                    :href="referralLink"
                                    target="_blank"
                                >
                                    <div class="text-xs text-purple dark:text-purple-140 font-medium">
                                        {{ referralLinkForView }}
                                    </div>

                                    <LinkIcon class="text-purple dark:text-purple-140"/>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="px-5 max-mob:px-0 py-3">
                    <div class="flex gap-x-3">
                        <div class="min-w-8 max-w-8 min-h-8 max-h-8 flex items-center justify-center">
                            <CheckIcon class="text-purple"/>
                        </div>

                        <div class="flex flex-col gap-y-3">
                            <div class="text-gray-370 dark:text-white font-medium">
                                Get 5% commission for each payment
                            </div>

                            <div class="text-sm text-gray-280">
                                You get paid commissions as soon as your referrals start making purchases on Dialics
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex justify-center w-full mt-8">
                <PrimaryBtn
                    class="w-32.5 max-mob:w-full"
                    @click="onStart"
                >
                    Let’s start
                </PrimaryBtn>
            </div>
        </div>
    </CustomDialog>

</template>

<script setup>
import { ref, computed } from 'vue'

import PartyPopper from '@/components/icons/PartyPopper.vue'
import CheckIcon from '@/components/icons/CheckIcon.vue'
import PrimaryBtn from '@/components/buttons/PrimaryBtn.vue'
import CustomDialog from '@/components/dialogs/CustomDialog.vue'
import LinkIcon from '@/components/icons/LinkIcon.vue'

import { splitUrlForRef } from '@/helpers/app-helper'
import { getWelcomeDialogLocalStorage, setWelcomeDialogLocalStorage } from '@/helpers/app-local-storage-helper'

import { useHeaderStore } from '@/store/headerStore'

const headerStore = useHeaderStore()

const show = ref(!getWelcomeDialogLocalStorage())

const referralLink = computed(() => headerStore.referralLink)
const referralLinkForView = computed(() => splitUrlForRef(referralLink.value))

function onStart() {
    setWelcomeDialogLocalStorage()
    show.value = false
}
</script>
